import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-minutes-field',
  templateUrl: './list-minutes-field.component.html',
  styleUrls: ['./list-minutes-field.component.scss']
})
export class ListMinutesFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
